import Image from "next/image";
import { useEffect, useState } from "react";
import { fetchGetCompanyBusinessHours, fetchGetCompanySiteSettings } from "../../../services/api";

export default function Footer({ company }) {

    const [businessHours, setBusinessHours] = useState([]);

    useEffect(() => {
        const fetchBusinessHours = async () => {
            const hours = [];
            try {
                const res = await fetchGetCompanyBusinessHours();
                if (res.monday && res.tuesday && res.wednesday && res.thursday && res.friday) {
                    const sameWeekdayHours =
                        res.mondayOpeningTime === res.tuesdayOpeningTime &&
                        res.mondayOpeningTime === res.wednesdayOpeningTime &&
                        res.mondayOpeningTime === res.thursdayOpeningTime &&
                        res.mondayOpeningTime === res.fridayOpeningTime &&
                        res.mondayClosingTime === res.tuesdayClosingTime &&
                        res.mondayClosingTime === res.wednesdayClosingTime &&
                        res.mondayClosingTime === res.thursdayClosingTime &&
                        res.mondayClosingTime === res.fridayClosingTime;

                    if (sameWeekdayHours) {
                        hours.push({ name: 'Segunda à Sexta', openingTime: res.mondayOpeningTime.slice(0, 5), closingTime: res.mondayClosingTime.slice(0, 5) });
                    } else {
                        if (res.monday) {
                            hours.push({ name: 'Segunda-feira', openingTime: res.mondayOpeningTime.slice(0, 5), closingTime: res.mondayClosingTime.slice(0, 5) });
                        }
                        if (res.tuesday) {
                            hours.push({ name: 'Terça-feira', openingTime: res.tuesdayOpeningTime.slice(0, 5), closingTime: res.tuesdayClosingTime.slice(0, 5) });
                        }
                        if (res.wednesday) {
                            hours.push({ name: 'Quarta-feira', openingTime: res.wednesdayOpeningTime.slice(0, 5), closingTime: res.wednesdayClosingTime.slice(0, 5) });
                        }
                        if (res.thursday) {
                            hours.push({ name: 'Quinta-feira', openingTime: res.thursdayOpeningTime.slice(0, 5), closingTime: res.thursdayClosingTime.slice(0, 5) });
                        }
                        if (res.friday) {
                            hours.push({ name: 'Sexta-feira', openingTime: res.fridayOpeningTime.slice(0, 5), closingTime: res.fridayClosingTime.slice(0, 5) });
                        }
                    }
                }
                if (res.saturday) {
                    hours.push({ name: 'Sábado', openingTime: res.saturdayOpeningTime.slice(0, 5), closingTime: res.saturdayClosingTime.slice(0, 5) });
                }
                if (res.sunday) {
                    hours.push({ name: 'Domingo', openingTime: res.sundayOpeningTime.slice(0, 5), closingTime: res.sundayClosingTime.slice(0, 5) });
                }
                if (res.holiday) {
                    hours.push({ name: 'Feriado', openingTime: res.holidayOpeningTime.slice(0, 5), closingTime: res.holidayClosingTime.slice(0, 5) });
                }
                setBusinessHours(hours);
            } catch (error) {
                console.error('Erro ao buscar os horários de funcionamento:', error);
            }
        };

        fetchBusinessHours();
    }, []);

    const [activePages, setActivePages] = useState([])
    useEffect(() => {
        const pages = []
        fetchGetCompanySiteSettings()
            .then(res => {
                res.showNew === true ? pages.push({ route: "novos", name: "0 Km" }) : null;
                res.showUsed === true ? pages.push({ route: "estoque", name: "Estoque" }) : null;
                res.showArmored === true ? pages.push({ route: "blindados", name: "Blindados" }) : null;
                res.showFinancing === true ? pages.push({ route: "financiamento", name: "Financiamento" }) : null;
                res.showVehiclePurchase === true ? pages.push({ route: "venda-seu-veiculo", name: "Venda seu Veículo" }) : null;
                res.showInsurance === true ? pages.push({ route: "seguro", name: "Seguro" }) : null;
                setActivePages(pages)
            })
    }, [])

    const formatPhone = (phone) => {
        if (!phone) return null;

        if (phone.length === 10) {
            return `(${phone.substring(0, 2)}) ${phone.substring(2, 6)}-${phone.substring(6, 10)}`;
        }

        if (phone.length === 11) {
            return `(${phone.substring(0, 2)}) ${phone.substring(2, 7)}-${phone.substring(7, 11)}`;
        }

        return phone;
    };

    const cnpjMask = (number) => {
        if (!number) return '';
        const cleaned = number.replace(/\D/g, '');
        return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    }

    return (
        <footer className="footer-section">
            <div className="footer-wrapper pt-120 pb-5 position-relative z-1 overflow-hidden">
                <Image
                    src={'/img/shapes/texture-bg.png'}
                    alt="rodape"
                    style={{ zIndex: -1 }}
                    fill
                />
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-xl-5 col-lg-5 col-md-12 mb-5 mb-lg-0">
                            <div className="footer-widget widget-basic">
                                <h3 className="widget-title-large mb-4 text-white">Tem alguma dúvida? Fale conosco e te ajudamos...</h3>
                                <p className="mb-4 text-white">Nossos vendedores possuem anos de experiência para tirar todas suas dúvidas e te dar o melhor atendimento do Brasil.</p>
                                
                                <div className="phone-box d-flex flex-column gap-3">
                                    {company.phone && (
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-primary text-white" style={{ width: '45px', height: '45px', minWidth: '45px' }}>
                                                <i className="flaticon-phone-call"></i>
                                            </div>
                                            <div>
                                                <a href={`tel:+55${company.phone}`}>
                                                    <h5 className="text-white mb-0">{formatPhone(company.phone)}</h5>
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                    {company.phone2 && (
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-primary text-white" style={{ width: '45px', height: '45px', minWidth: '45px' }}>
                                                <i className="flaticon-phone-call"></i>
                                            </div>
                                            <div>
                                                <a href={`tel:+55${company.phone2}`}>
                                                    <h5 className="text-white mb-0">{formatPhone(company.phone2)}</h5>
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                    {company.whatsapp && (
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="icon-wrapper d-flex align-items-center justify-content-center rounded-circle bg-success text-white" style={{ width: '45px', height: '45px', minWidth: '45px' }}>
                                                <i className="fab fa-whatsapp"></i>
                                            </div>
                                            <div>
                                                <a target="_blank" rel="noreferrer" href={`https://api.whatsapp.com/send?phone=${company.whatsapp}&text=${company.whatsappDefaultMessage ? company.whatsappDefaultMessage : "Olá, gostaria de tirar algumas dúvidas com um consultor. Alguém disponível para me atender agora?"}`}>
                                                    <h5 className="text-white mb-0">{formatPhone(company.whatsapp)}</h5>
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-6 col-lg-7 col-md-12">
                            <div className="row">
                                <div className="col-md-4 col-sm-6 mb-4 mb-md-0">
                                    <div className="footer-widget footer-nav-widget">
                                        <h6 className="widget-title text-white mb-3">Sobre Nós</h6>
                                        <ul className="footer-nav list-unstyled">
                                            <li className="mb-2"><a href="/sobre-nos" className="text-decoration-none hover-text-white">Sobre a Empresa</a></li>
                                            <li className="mb-2"><a href="/contato" className="text-decoration-none hover-text-white">Contato</a></li>
                                            <li className="mb-2"><a href="/blog" className="text-decoration-none hover-text-white">Blog</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 mb-4 mb-md-0">
                                    <div className="footer-widget footer-nav-widget">
                                        <h6 className="widget-title text-white mb-3">Links Rápidos</h6>
                                        <ul className="footer-nav list-unstyled">
                                            {activePages.map((page, index) => (
                                                <li key={index} className="mb-2">
                                                    <a href={`/${page.route}`} className="text-decoration-none hover-text-white">
                                                        {page.name}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-12 mb-4 mb-md-0">
                                    <h6 className="widget-title text-white mb-3">Siga-nos</h6>
                                    <div className="d-flex gap-3">
                                        {company.youtube && (
                                            <a className="text-white bg-danger rounded-circle d-flex align-items-center justify-content-center" 
                                               href={company.youtube} 
                                               target={'_blank'} 
                                               rel="noreferrer" 
                                               aria-label="YouTube"
                                               style={{ width: '40px', height: '40px', background: '#FF0000' }}>
                                                <i className="fab fa-youtube"></i>
                                            </a>
                                        )}
                                        {company.facebook && (
                                            <a className="text-white bg-primary rounded-circle d-flex align-items-center justify-content-center" 
                                               href={company.facebook} 
                                               target={'_blank'} 
                                               rel="noreferrer" 
                                               aria-label="Facebook"
                                               style={{ width: '40px', height: '40px', background: '#1877F2' }}>
                                                <i className="fab fa-facebook-f"></i>
                                            </a>
                                        )}
                                        {company.instagram && (
                                            <a className="text-white rounded-circle d-flex align-items-center justify-content-center" 
                                               href={company.instagram} 
                                               target={'_blank'} 
                                               rel="noreferrer" 
                                               aria-label="Instagram"
                                               style={{ width: '40px', height: '40px', background: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285AEB 90%)' }}>
                                                <i className="fab fa-instagram"></i>
                                            </a>
                                        )}
                                        {company.tiktok && (
                                            <a className="text-white rounded-circle d-flex align-items-center justify-content-center" 
                                               href={company.tiktok} 
                                               target={'_blank'} 
                                               rel="noreferrer" 
                                               aria-label="TikTok"
                                               style={{ width: '40px', height: '40px', background: '#000000' }}>
                                                <i className="fab fa-tiktok"></i>
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4 pt-3 border-top border-white border-opacity-10">
                                <div className="col-md-6 mb-3 mb-md-0">
                                    <h6 className="text-white mb-3">Horário de Funcionamento</h6>
                                    <ul className="list-unstyled">
                                        {businessHours.map((hour, index) => (
                                            <li key={index} className="text-white mb-1" style={{ fontSize: "14px" }}>
                                                <span className="d-inline-block" style={{ minWidth: '120px' }}>{hour.name}:</span> 
                                                {hour.openingTime} - {hour.closingTime}
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="col-md-6">
                                    <h6 className="text-white mb-3">Endereço</h6>
                                    <p className="text-white mb-2" style={{ fontSize: "14px" }}>
                                        <i className="fas fa-map-marker-alt me-2"></i>
                                        {`${company.address} - ${company.city} - ${company.federativeUnit}`}
                                    </p>
                                    <p className="text-white mb-2" style={{ fontSize: "14px" }}>
                                        <i className="fas fa-envelope me-2"></i>
                                        {company.email || 'contato@empresa.com.br'}
                                    </p>
                                    {company.cnpj && (
                                        <p className="text-white mb-0" style={{ fontSize: "13px" }}>
                                            <i className="fas fa-building me-2"></i>
                                            CNPJ: {cnpjMask(company.cnpj)}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-copyright mt-5 pt-4 border-top border-white border-opacity-10">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-7 text-center text-md-start">
                                <p className="mb-0 text-white small">
                                    &copy; {new Date().getFullYear()} Todos os direitos reservados. 
                                    Desenvolvido por <a href="https://bndv.com.br" target="_blank" rel="noreferrer" className="text-primary text-decoration-none">BNDV - Banco Nacional de Veículos</a>
                                </p>
                            </div>
                            <div className="col-md-5 text-center text-md-end mt-2 mt-md-0">
                                <a href="/termos" className="text-white text-decoration-none small hover-text-white">
                                    Termo de Uso e Política de Privacidade
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}